import { Team } from '../types/team';
import BaseEntityService from './baseEntityService';

const serviceUrlSuffix = 'v1/teams'

class TeamService extends BaseEntityService<Team> {
    constructor() {
        super(serviceUrlSuffix);
    }
}

export const teamService = new TeamService();